import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        name: String,
        placement: String
    }

    connect() {
        this.tracked = false;
        this.setupIntersectionObserver();
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    setupIntersectionObserver() {
        // Track impression when ad is 50% visible for at least 1 second
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        // Ad is visible, start timer
                        this.visibilityTimer = setTimeout(() => {
                            this.trackImpression();
                        }, 1000); // Wait 1 second
                    } else {
                        // Ad is no longer visible, cancel timer
                        if (this.visibilityTimer) {
                            clearTimeout(this.visibilityTimer);
                        }
                    }
                });
            },
            { threshold: 0.5 } // Trigger when 50% visible
        );

        this.observer.observe(this.element);
    }

    trackImpression() {
        // Only track once per page load
        if (this.tracked) return;
        this.tracked = true;

        fetch('/ads/impression', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
            },
            body: JSON.stringify({
                ad_name: this.nameValue,
                placement: this.placementValue,
                page_path: window.location.pathname
            })
        });
    }
}